import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Bell, CheckCheck } from "lucide-react";
import { toast } from "sonner";
import { Link } from "react-router-dom";

export default function Notifications() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/notifications").then(r => setItems(r.data));
  useEffect(() => { load(); }, []);
  const markAll = async () => { await api.post("/notifications/mark-all-read"); toast.success("All marked read"); load(); };
  const scan = async () => { try { await api.post("/notifications/trigger-scan"); toast.success("Scan started"); setTimeout(load, 1500); } catch { toast.error("Not allowed"); } };
  const unread = items.filter(x => !x.read).length;

  return (
    <div className="space-y-6 animate-in">
      <div className="flex items-end justify-between">
        <div>
          <div className="text-[11px] uppercase tracking-[0.3em] text-muted-foreground">Alerts</div>
          <h1 className="font-serif-display text-3xl">Notifications</h1>
          <p className="text-sm text-muted-foreground mt-1">{unread} unread. Overdue follow-ups and site-visit reminders are auto-generated by scheduled cron.</p>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" onClick={scan} data-testid="notif-scan-btn">Run Scan Now</Button>
          <Button onClick={markAll} data-testid="notif-mark-all-btn"><CheckCheck size={14} className="mr-1"/> Mark all read</Button>
        </div>
      </div>
      <Card className="divide-y divide-border">
        {items.length === 0 && <div className="p-10 text-center text-muted-foreground text-sm">No notifications.</div>}
        {items.map(n => (
          <div key={n.id} className={`p-4 flex items-start gap-3 ${!n.read ? "bg-accent/5" : ""}`} data-testid={`notif-${n.id}`}>
            <div className={`mt-0.5 w-2 h-2 rounded-full ${!n.read ? "bg-accent" : "bg-border"}`}/>
            <div className="flex-1">
              <div className="flex items-center gap-2">
                <span className="text-[10px] uppercase tracking-widest text-muted-foreground">{n.kind}</span>
                <span className="text-[10px] text-muted-foreground">{new Date(n.created_at).toLocaleString()}</span>
              </div>
              <div className="font-medium mt-1">{n.title}</div>
              <div className="text-sm text-muted-foreground">{n.body}</div>
              {n.link && <Link to={n.link} className="text-xs text-accent hover:underline mt-1 inline-block">Open →</Link>}
            </div>
          </div>
        ))}
      </Card>
    </div>
  );
}
